module.exports = __webpack_public_path__ + "static/media/tabela.5e695f6e.png";